import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/UIKibrary.css'
import '@/config/ydkConfig.js'
import '@/assets/css/reset.css'

createApp(App).mount('#app')

